import { useTheme } from "@/services/ThemeContext/ThemeContext";
import { cn } from "@/shadcn/lib/utils";
import React from "react";

type CustomLoaderProps = {
  containerClassName?: string;
  loaderClassName?: string;
};

const CustomLoader: React.FC<CustomLoaderProps> = ({
  containerClassName,
  loaderClassName,
}) => {
  const { customLoaderImage } = useTheme();
  return (
    <div className={cn("flex items-center justify-center", containerClassName)}>
      {customLoaderImage ? (
        <img
          src={customLoaderImage}
          alt="Loading..."
          className={cn(
            "h-80 max-h-full w-64 max-w-full object-contain p-2",
            loaderClassName
          )}
          onError={(e) => {
            // replace with fallback jsx if image fails to load
            const target = e.target as HTMLImageElement;
            target.onerror = null; // prevents looping
            target.style.display = "none"; // hide the image
            const fallbackLoader = document.getElementById("fallback-loader");
            if (fallbackLoader) {
              fallbackLoader.style.display = "block"; // show the fallback loader
            }
          }}
        />
      ) : (
        <div className="border-primary h-8 w-8 animate-spin rounded-full border-4 border-t-4 border-t-transparent"></div>
      )}
      <div
        id="fallback-loader"
        style={{
          display: "none",
        }}
        className="border-primary h-8 w-8 animate-spin rounded-full border-4 border-t-4 border-t-transparent"
      ></div>
    </div>
  );
};

export default CustomLoader;
